module.exports = __webpack_public_path__ + "static/media/loading.fe730f99.svg";